/* ==========================================================================
   CL · Hero Doto — comportamiento del carrusel
   Port de doto-home-hero-v2.js (doto.com.mx): scroll-snap nativo con
   autoplay, loop, flechas, dots, pausa al hover/touch y soporte del
   editor de temas. Sin dependencias (no usa Swiper).
   ========================================================================== */

class CLHeroDoto {
	constructor(section) {
		this.section = section;
		this.track = section.querySelector('[data-cl-herod-track]');
		this.slides = Array.from(section.querySelectorAll('[data-cl-herod-slide]'));
		this.dots = Array.from(section.querySelectorAll('[data-cl-herod-dot]'));
		this.prev = section.querySelector('[data-cl-herod-prev]');
		this.next = section.querySelector('[data-cl-herod-next]');
		this.autoplay = section.dataset.autoplay === 'true';
		this.loop = section.dataset.loop === 'true';
		this.delay = (Number.parseInt(section.dataset.autoplaySpeed || '6', 10) || 6) * 1000;
		this.index = 0;
		this.timer = null;
		this.scrollTimer = null;

		if (!this.track || this.slides.length <= 1) return;

		this.onScroll = this.onScroll.bind(this);
		this.onVisibility = this.onVisibility.bind(this);
		this.onPointerDown = this.onPointerDown.bind(this);

		this.bind();
		this.updateDots(0);
		this.start();
	}

	bind() {
		if (this.prev) this.prev.addEventListener('click', () => this.goTo(this.index - 1));
		if (this.next) this.next.addEventListener('click', () => this.goTo(this.index + 1));
		this.track.addEventListener('scroll', this.onScroll, { passive: true });
		this.track.addEventListener('pointerdown', this.onPointerDown, { passive: true });
		this.track.addEventListener('mouseenter', () => this.stop());
		this.track.addEventListener('mouseleave', () => this.start());
		document.addEventListener('visibilitychange', this.onVisibility);

		this.dots.forEach((dot) => {
			dot.addEventListener('click', () => this.goTo(Number.parseInt(dot.dataset.clHerodDot || '0', 10)));
		});
	}

	onPointerDown() {
		/* Pausa el autoplay cuando el usuario arrastra y lo reanuda después */
		this.stop();
		window.setTimeout(() => this.start(), this.delay * 1.25);
	}

	onVisibility() {
		if (document.hidden) this.stop();
		else this.start();
	}

	onScroll() {
		window.clearTimeout(this.scrollTimer);
		this.scrollTimer = window.setTimeout(() => {
			const width = this.track.clientWidth || 1;
			const nextIndex = Math.round(this.track.scrollLeft / width);
			this.index = Math.max(0, Math.min(nextIndex, this.slides.length - 1));
			this.updateDots(this.index);
		}, 80);
	}

	goTo(index, smooth = true) {
		if (!this.slides.length) return;
		let target = index;

		if (this.loop) {
			target = (target + this.slides.length) % this.slides.length;
		} else {
			target = Math.max(0, Math.min(target, this.slides.length - 1));
		}

		this.index = target;
		this.track.scrollTo({
			left: this.track.clientWidth * target,
			behavior: smooth && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto'
		});
		this.updateDots(target);
		this.start();
	}

	updateDots(index) {
		this.dots.forEach((dot, dotIndex) => {
			const active = dotIndex === index;
			dot.classList.toggle('is-active', active);
			dot.setAttribute('aria-current', active ? 'true' : 'false');
		});
	}

	start() {
		this.stop();
		if (!this.autoplay || document.hidden) return;
		this.timer = window.setInterval(() => this.goTo(this.index + 1), this.delay);
	}

	stop() {
		if (this.timer) {
			window.clearInterval(this.timer);
			this.timer = null;
		}
	}

	destroy() {
		this.stop();
		window.clearTimeout(this.scrollTimer);
		if (this.track) {
			this.track.removeEventListener('scroll', this.onScroll);
			this.track.removeEventListener('pointerdown', this.onPointerDown);
		}
		document.removeEventListener('visibilitychange', this.onVisibility);
	}
}

const clHeroDotoInstances = new Map();

function initCLHeroDoto(section) {
	if (!section || clHeroDotoInstances.has(section)) return;
	clHeroDotoInstances.set(section, new CLHeroDoto(section));
}

function destroyCLHeroDoto(section) {
	const instance = clHeroDotoInstances.get(section);
	if (instance) instance.destroy();
	clHeroDotoInstances.delete(section);
}

function initAllCLHeroDoto() {
	document.querySelectorAll('[data-cl-herod]').forEach(initCLHeroDoto);
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initAllCLHeroDoto);
} else {
	initAllCLHeroDoto();
}

/* Editor de temas */
document.addEventListener('shopify:section:load', (event) => {
	if (!event.target.querySelectorAll) return;
	event.target.querySelectorAll('[data-cl-herod]').forEach(initCLHeroDoto);
});

document.addEventListener('shopify:section:unload', (event) => {
	if (!event.target.querySelectorAll) return;
	event.target.querySelectorAll('[data-cl-herod]').forEach(destroyCLHeroDoto);
});

document.addEventListener('shopify:block:select', (event) => {
	const slide = event.target.closest ? event.target.closest('[data-cl-herod-slide]') : null;
	const section = event.target.closest ? event.target.closest('[data-cl-herod]') : null;
	if (!slide || !section) return;
	initCLHeroDoto(section);
	const instance = clHeroDotoInstances.get(section);
	if (instance) {
		instance.goTo(Number.parseInt(slide.dataset.index || '0', 10), false);
		instance.stop();
	}
});
